import { PAGES_TYPES } from 'constants/pagesTypes';

import { oneCMultiTabsCardsData } from './oneCData';
import { bodyShopMultiTabsCardsData } from './bodyshopData';
import { maintenanceSupportMultiTabsCardsData } from './maintenanceSupportData';

export const multiTabsCardsBlockPropsSelector = {
  [PAGES_TYPES.maintenanceSupport]: maintenanceSupportMultiTabsCardsData,
  [PAGES_TYPES.bodyShop]: bodyShopMultiTabsCardsData,
  [PAGES_TYPES.oneC]: oneCMultiTabsCardsData,
};
